import React from "react";
import ReactDOM from "react-dom";

import { cn } from "@/lib/cn";

// From 992px the panel is `--side-panel-width` wide, which `MainViewLayout` pads its content by
export const SidePanelPortal = (props: { children: React.ReactNode; isOpen: boolean }) => {
  const { children, isOpen } = props;

  let root = document.querySelector("body > #side-panel-portal");
  if (!root) {
    root = Object.assign(document.createElement("div"), { id: "side-panel-portal" });
    document.body.appendChild(root);
  }

  return ReactDOM.createPortal(
    <div
      className={cn(
        "fixed inset-y-0 right-0 z-500 h-full w-full overscroll-contain bg-background transition-[translate,box-shadow] duration-200 ease-out min-[992px]:w-side-panel",
        isOpen ? "shadow-panel" : "translate-x-full",
      )}
    >
      {children}
    </div>,
    root,
  );
};
